import type { DashboardQueryState } from '../hooks/useFunnelListQuery';

/** SPEC-003 §45: differentiate empty states by current filter context. */
export function emptyStateMessage(query: DashboardQueryState, total: number): string | null {
  if (total > 0) return null;
  if (query.q) return `Nenhum resultado para "${query.q}".`;
  if (query.folderId) return 'Esta pasta está vazia.';
  if (query.favorite) return 'Ainda não há favoritos.';
  if (query.status === 'archived') return 'Não há funis arquivados.';
  return 'Ainda não há funis. Crie o primeiro para começar.';
}
